import { useEffect, useRef, useState } from 'react'
import { RxHamburgerMenu } from 'react-icons/rx'
import Sidebar from '../Common/Sidebar/Sidebar'
import AdminProfile from '../AdminProfile/AdminProfile'
import MobileSideBar from '../MobileSideBar/MobileSideBar'

const MainLayout = ({ children }) => {
  const dropdownRef = useRef(null)
  const sidebarRef = useRef(null)
  const [isOpen, setIsOpen] = useState(false)
  const [toggle, setToggle] = useState(false)
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem('sidebarCollapsed') === '1',
  )

  const toggleSidebar = () => {
    setCollapsed(prev => {
      try {
        localStorage.setItem('sidebarCollapsed', prev ? '' : '1')
      } catch {
        /* storage unavailable */
      }
      return !prev
    })
  }

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  useEffect(() => {
    const handleClickOutside = event => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setToggle(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const isSidebarVisible = !(
    location.pathname === '/profile' || location.pathname === '/onboarding'
  )

  return (
    <div className="flex h-screen w-full min-h-0 overflow-hidden">
      {isSidebarVisible && (
        <Sidebar collapsed={collapsed} onToggle={toggleSidebar} />
      )}

      <div
        className={`flex min-h-0 flex-1 flex-col ml-0 ${
          isSidebarVisible ? (collapsed ? 'xl:ml-[70px]' : 'xl:ml-[290px]') : 'xl:ml-[290px]'
        }`}
      >
        <div
          className="flex shrink-0 justify-center p-6"
          style={{ borderBottom: '1px solid #e5e7eb' }}
        >
          <div className="w-[90%] max-w-[1400px] mx-auto flex justify-between xl:justify-end items-center">
            <div className="xl:hidden block" onClick={() => setToggle(!toggle)}>
              <RxHamburgerMenu className="w-5 h-5" />
            </div>

            {toggle && (
              <div ref={sidebarRef}>
                <MobileSideBar toggle={toggle} setToggle={setToggle} />
              </div>
            )}

            <div ref={dropdownRef}>
              <AdminProfile setIsOpen={setIsOpen} isOpen={isOpen} />
            </div>
          </div>
        </div>

        <div className="mx-auto flex w-full min-h-0 flex-1 justify-center overflow-y-auto py-6">
          <div className="mx-auto w-[92%] max-w-[1400px]">
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MainLayout
